module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saveShareHolders"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "shareholderTitle"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.shareholder_label')) + " " + _vm._s(_vm.shareholderNumber) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('document-pi-V2', {
    attrs: {
      "title": _vm.$t('iframe_page.doctypes.id'),
      "subTitle": _vm.$t('iframe_page.docdesc.id')
    },
    on: {
      "showInputs": function($event) {
        _vm.showInputs = true
      },
      "validateBtn": _vm.validateBtn
    },
    model: {
      value: (_vm.idDocs),
      callback: function($$v) {
        _vm.idDocs = $$v
      },
      expression: "idDocs"
    }
  }), _vm._v(" "), (_vm.showInputs || _vm.hasSavedInputs) ? _c('div', [_c('div', {
    staticClass: "allRow"
  }, [_c('div', {
    staticClass: "rowLeft selectionBloc genderBlock",
    class: {
      selectionBlocActive: _vm.gender === 'female'
    },
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.changeGenderTo('female')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('iframe_page.mistress')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "rowRight selectionBloc genderBlock",
    class: {
      selectionBlocActive: _vm.gender === 'male'
    },
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.changeGenderTo('male')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('iframe_page.mister')) + "\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-0"
  }, [(_vm.gender !== 'female' && _vm.gender !== 'male') ? _c('small', {
    staticClass: "d-flex text-danger pl-2"
  }, [_vm._v(_vm._s(_vm.$t('errors.is_mandatory', {
    mandatoryValue: this.$t('iframe_page.gender')
  })))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "allRow"
  }, [_c('adaptative-placeholder-input', {
    staticClass: "rowLeft",
    attrs: {
      "label": _vm.$t('iframe_page.firstname'),
      "onBlur": _vm.checkFirstname,
      "hasError": _vm.firstnameHasError,
      "errorMessage": _vm.firstnameErrorMessage
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    staticClass: "rowRight",
    attrs: {
      "label": _vm.$t('iframe_page.lastname'),
      "onBlur": _vm.checkLastname,
      "hasError": _vm.lastnameHasError,
      "errorMessage": _vm.lastnameErrorMessage
    },
    model: {
      value: (_vm.lastname),
      callback: function($$v) {
        _vm.lastname = $$v
      },
      expression: "lastname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "allRow"
  }, [_c('adaptative-placeholder-input', {
    staticClass: "rowLeft",
    attrs: {
      "label": _vm.$t('iframe_page.birthdate'),
      "onBlur": _vm.checkBirthdate,
      "hasError": _vm.birthdateHasError,
      "errorMessage": _vm.birthdateErrorMessage
    },
    model: {
      value: (_vm.birthdate),
      callback: function($$v) {
        _vm.birthdate = $$v
      },
      expression: "birthdate"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    staticClass: "rowRight",
    attrs: {
      "label": _vm.$t('iframe_page.birthtown'),
      "onBlur": _vm.checkBirthtown,
      "hasError": _vm.birthtownHasError,
      "errorMessage": _vm.birthtownErrorMessage
    },
    model: {
      value: (_vm.birthtown),
      callback: function($$v) {
        _vm.birthtown = $$v
      },
      expression: "birthtown"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "allRow"
  }, [_c('adaptative-placeholder-input', {
    staticClass: "rowLeft",
    attrs: {
      "label": _vm.$t('iframe_page.birthcountry'),
      "onBlur": _vm.checkBirthcountry,
      "hasError": _vm.birthcountryHasError,
      "errorMessage": _vm.birthcountryErrorMessage
    },
    model: {
      value: (_vm.birthcountry),
      callback: function($$v) {
        _vm.birthcountry = $$v
      },
      expression: "birthcountry"
    }
  }), _vm._v(" "), _c('adaptative-placeholder-input', {
    staticClass: "rowRight",
    attrs: {
      "label": _vm.$t('iframe_page.nationality'),
      "onBlur": _vm.checkNationality,
      "hasError": _vm.nationalityHasError,
      "errorMessage": _vm.nationalityErrorMessage
    },
    model: {
      value: (_vm.nationality),
      callback: function($$v) {
        _vm.nationality = $$v
      },
      expression: "nationality"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.id_card_number'),
      "onBlur": _vm.checkIdCard,
      "hasError": _vm.idCardHasError,
      "errorMessage": _vm.idCardErrorMessage
    },
    model: {
      value: (_vm.id_card_number),
      callback: function($$v) {
        _vm.id_card_number = $$v
      },
      expression: "id_card_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('adaptative-placeholder-input', {
    attrs: {
      "label": _vm.$t('iframe_page.percentage'),
      "inputFormating": _vm.percentageFormating,
      "onBlur": _vm.checkPercentage,
      "hasError": _vm.percentageHasError,
      "errorMessage": _vm.percentageErrorMessage
    },
    model: {
      value: (_vm.percentage),
      callback: function($$v) {
        _vm.percentage = $$v
      },
      expression: "percentage"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('document-proof-address', {
    attrs: {
      "title": _vm.$t('iframe_page.doctypes.proof_address'),
      "subTitle": _vm.$t('iframe_page.docdesc.proof_address')
    },
    model: {
      value: (_vm.proofOfAdress),
      callback: function($$v) {
        _vm.proofOfAdress = $$v
      },
      expression: "proofOfAdress"
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f42174a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f42174a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/Shareholder.vue
// module id = 2307
// module chunks = 2